// takes the MS JSON Date used by Xero API and returns a javascript Date object
export const parseXeroDate = jsonDate => {
  return new Date(parseInt(jsonDate.substr(6)));
};
